import React, { useState } from "react";
import LayoutWrapper from "../layout/LayoutWrapper";
import Header from "../layout/Header";
import axios from "../../api/axios";

function ZoomTest() {
  const [topic, setTopic] = useState("");
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState(30);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const createMeeting = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const url = "/zoom/meetings";
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
        },
      };
      const data = {
        topic,
        start_time: startTime,
        duration,
      };
      const res = await axios.post(url, data, config);
      setResponse(res.data.data);
    } catch (error) {
      console.error("Error creating meeting:", error);
      setResponse({ error: "Failed to create meeting" });
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #444",
    backgroundColor: "#1f1f1f",
    color: "white",
    marginTop: "5px",
  };

  const labelStyle = {
    fontWeight: 500,
    marginBottom: "5px",
    display: "block",
  };

  return (
    <LayoutWrapper>
      <Header />

      <div
        style={{
          padding: "30px",
          backgroundColor: "#292929",
          minHeight: "100vh",
          color: "white",
        }}
      >
        <div
          style={{
            margin: "0 auto",
            background: "#1f1f1f",
            padding: "24px",
            borderRadius: "10px",
            border: "1px solid #444",
          }}
        >
          <h2 style={{ color: "#10b981", marginBottom: "20px" }}>
            Zoom Meeting Test
          </h2>

          <form onSubmit={createMeeting}>
            {/* Topic */}
            <div style={{ marginBottom: "16px" }}>
              <label style={labelStyle}>Topic</label>
              <input
                type="text"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                required
                style={inputStyle}
              />
            </div>

            {/* Start Time */}
            <div style={{ marginBottom: "16px" }}>
              <label style={labelStyle}>Start Time</label>
              <input
                type="datetime-local"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                required
                style={inputStyle}
              />
            </div>

            {/* Duration */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Duration (mins)</label>
              <input
                type="number"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                required
                style={inputStyle}
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "none",
                backgroundColor: loading ? "#555" : "#10b981",
                color: "#000",
                fontWeight: 600,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Creating..." : "Create Meeting"}
            </button>
          </form>

          {/* Response */}
          {response && (
            <div style={{ marginTop: "20px" }}>
              <h3 style={{ color: "#10b981" }}>Response</h3>
              <pre
                style={{
                  background: "#111",
                  padding: "12px",
                  borderRadius: "6px",
                  overflowX: "auto",
                  color: "#ddd",
                  border: "1px solid #444",
                }}
              >
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    </LayoutWrapper>
  );
}

export default ZoomTest;